import { BehaviorSubject } from 'rxjs';
import Configuration from '../core/configuration';
import { sendJsonData } from '../core/web-client';
import { history } from '../core/history'
 

const currentUserVariable = 'currentUser';
const currentUserSubject = new BehaviorSubject(getUserFromStorage(currentUserVariable));

   

const login = async (username, password) => {     
    //const loginUrl = Configuration.traffic.login; 
    const loginUrl = "/Persons/authenticate"; 
    const response = await sendJsonData(loginUrl, {username, password}, 'POST');    
    if (response.isSuccess){
        const user = { 
            token: response.result.token,
            expires: response.result.expires,
            username: response.result.username,
            roleNames: response.result.roleNames            
        };
     
        saveUserInStorage(user);
        currentUserSubject.next(user);
        // updateUserToken();
        
        return {
            isSuccess: true,
            user: user
        }; 
    }
    else{
        return {
            isSuccess: false,
            result: response
        };
    }    
}

const logout = () => { 
    localStorage.removeItem(currentUserVariable);
    currentUserSubject.next(null);
}

function saveUserInStorage(user) {
    localStorage.setItem(currentUserVariable, JSON.stringify(user));
}

function getUserFromStorage() {
    return JSON.parse(localStorage.getItem(currentUserVariable));
}

export const authenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue () { 
        return currentUserSubject.value 
    },
    isUserInRoles(roles) {  
        return currentUserSubject.value && currentUserSubject.value.roleNames.some(item => roles.indexOf(item) > -1)
    }
};
